module.exports = __webpack_public_path__ + "5729ecfe842308514e27f5b304b32e5f.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/sn_logo_black.png
// module id = 180
// module chunks = 0